import * as Sentry from '@sentry/browser'

const isProd = process.env.NODE_ENV === 'production'

if (isProd) {
	Sentry.init({
		environment: process.env.NODE_ENV,
		dsn: process.env.REACT_APP_SENTRY_DSN,
		beforeSend(event) {
			// TODO: ignore this stuff
			return event
		}
	})
}

export const logError = error => {
	if (isProd) {
		Sentry.captureEvent(error)
	} else {
		console.error(error)
	}
}

export const setLogScope = ({ user }) => {
	Sentry.configureScope(scope => {
		if (user) {
			scope.setUser({
				id: user.id,
				email: user.email,
				companyId: user.company.id,
				companyName: user.company.name
			})
		}
	})
}
